<template>
    <div id="user-filters" class="filters">
        <div class="panel-heading">
            <h4 class="panel-title" data-toggle="collapse" data-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                <a data-toggle="collapse" href="#collapse1" class="">Szűrők</a>
                <i class="fas fa-angle-down float-right text-dark"></i>
            </h4>
        </div>
        <div id="collapse1" class="panel-collapse collapse">
            <div class="panel-body filter-panel-body">
                <div class="row form-group">
                    <div class="col-sm-3">
                        <label class="control-label">Név</label>
                        <input type="text" class="form-control" v-model="filter.q"/>
                    </div>
                    <div class="col-sm-3">
                        <label class="control-label">E-mail</label>
                        <input type="text" class="form-control" v-model="filter.email"/>
                    </div>
                    <div class="col-sm-3">
                        <label class="control-label">Típus</label>
                        <b-form-select v-model="filter.is_admin" class="form-control" :options="type_list"></b-form-select>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-lg-2">
                        <button class="btn btn-primary" @click="applyFiltersClick">Keresés</button>
                    </div>
                    <div class="col-lg-2">
                        <button class="btn btn-secondary" @click="resetFilters">Törlés</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import Datepicker from 'vuejs-datepicker';
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'invoice-filters',
        data(){
            return{
                type_list: [
                    { value: null, text: '-Minden típus-' },
                    { value: 0, text: 'Felhasználó'},
                    { value: 1, text: 'Adminisztrátor'},
                ],
            }
        },
        components: {

        },
        computed: {
            ...mapGetters([
                'users',
                'userFilters',
            ]),
            filter: {
                get: function() {
                    return this.userFilters ? this.userFilters : {};
                },
                set: function(newVal) {
                    return newVal;
                }
            }
        },
        methods: {
            ...mapActions([
                'getUsers',
            ]),
            applyFiltersClick() {
                this.$set(this.filter, 'page', 1);
                this.$router.push({
                        path: '/users',
                        params: {
                            page: 1,
                        }
                    }
                );
                this.applyFilters();
            },
            applyFilters() {
                this.getUsers({
                    filters: this.filter,
                });
            },
            resetFilters() {
                this.$store.commit('setUserFilters', {
                    q: '',
                    email: '',
                    page: 1,
                    is_admin: '',
                });
                this.applyFilters();
            },
        },
        mounted(){
            this.resetFilters();
        }
    }
</script>

<style scoped="">

</style>